// extracted by css-extract-rspack-plugin
export default {"root":"xCOUcIQnNxc9el99","action":"jcgdUVVBFgcAd9Z2","primary":"ZiwN5HQ0Md4_9S2G","secondary":"kUDw8kddYGcttx4h"};